import PropTypes from 'prop-types';
import RawHtml from '../RawHtml/RawHtml';
import styles from './Stepper.module.scss';

const Stepper = ({ steps = [] }) => {
    if (!steps.length) {
        return null;
    }

    return (
        <ol className={styles['Stepper']}>
            {steps.map((step, index) => (
                <li key={index} className={styles['Stepper__Step']}>
                    <span
                        className={styles['Stepper__Number']}
                        aria-hidden="true">
                        {index + 1}
                    </span>
                    <div className={styles['Stepper__Text']}>
                        <RawHtml html={step.text} />
                    </div>
                </li>
            ))}
        </ol>
    );
};

Stepper.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
        })
    ),
};

export default Stepper;
